import { render } from "./TaskListPage.vue?vue&type=template&id=70bfac55&ts=true"
import script from "./TaskListPage.vue?vue&type=script&lang=ts"
export * from "./TaskListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__